import { render, staticRenderFns } from "./LdpFormDanhGia.vue?vue&type=template&id=524a8bf8&scoped=true&"
import script from "./LdpFormDanhGia.vue?vue&type=script&lang=js&"
export * from "./LdpFormDanhGia.vue?vue&type=script&lang=js&"
import style0 from "./LdpFormDanhGia.vue?vue&type=style&index=0&id=524a8bf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524a8bf8",
  null
  
)

export default component.exports